import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, delay, finalize } from 'rxjs/internal/operators';

import { GenericService } from '../../service/GenericService.service';
import { Payloc } from '../model/Payloc.model';
import { apiURL, paylocEndpoint, defaultSearchDelay } from '../../constants';
import { SpinnerService } from '../../service/spinner.service';
import {FilterToken} from '../model/filter-token.model';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import {DropdownService} from "../../dropdowns/dropdown.service";

const INIT_DATA = [];

@Injectable({
  providedIn: 'root'
})
export class PaylocService extends GenericService<Payloc> {

  private dataStore = new BehaviorSubject(INIT_DATA);
  data$: Observable<Payloc[]> = this.dataStore.asObservable();
  public hasSearched = false;
  public hasSearchResults = false;
  public hasFilterTokens = false;

  public payloc: Payloc;
  public paylocSearch: Payloc = new Payloc();

  public filterTokens: any[] = [];
  public canSearch = false;

  public currentPage: number;
  public totalPages: number;
  public totalElements: number;

  constructor(
    protected http: HttpClient,
    private spinnerService: SpinnerService,
    public flashMessagesService: FlashMessagesService,
    public dropdownService: DropdownService
  ) {
    super(http, apiURL + paylocEndpoint, flashMessagesService);
  }

  resetFilters(): void {
    this.paylocSearch = new Payloc();
    this.canSearch = false;
    this.filterTokens = [];
  }

  canSearchFn(): boolean {
    this.canSearch = !!this.paylocSearch.customerNum || !!this.paylocSearch.paymentNum || !!this.paylocSearch.payName || !!this.paylocSearch.memberLevel;
    return this.canSearch;
  }

  displayFilterTokens(): void {

    const filterTokens: FilterToken[] = [];

    if (this.paylocSearch.customerNum) {
      const token: FilterToken = {
        name: 'Customer Number',
        value: this.paylocSearch.customerNum,
        obj: 'customerNum'
      };

      filterTokens.push(token);
    }

    if (this.paylocSearch.paymentNum) {
      const token: FilterToken = {
        name: 'Subpayment ID',
        value: this.paylocSearch.paymentNum,
        obj: 'paymentNum'
      };

      filterTokens.push(token);
    }

    if (this.paylocSearch.payName) {
      const token: FilterToken = {
        name: 'Payloc Name',
        value: this.paylocSearch.payName,
        obj: 'payName'
      };

      filterTokens.push(token);
    }

    if (this.paylocSearch.memberLevel) {
      const token: FilterToken = {
        name: 'Member Level',
        value: this.paylocSearch.memberLevelLabel,
        obj: 'memberLevel'
      };

      filterTokens.push(token);
    }

    this.filterTokens = filterTokens;
    this.hasFilterTokens = filterTokens.length > 0;

    if (!this.hasFilterTokens) {
      this.hasSearched = false;
    }


  }

  getPaylocs(page) {
    if (this.canSearchFn()) {
      this.searchPaylocs(page);
    } else {
      this.getAllPaylocs(page);
    }
  }

  getAllPaylocs(page) {
    this.spinnerService.startSpinner();
    this.getPage(page).pipe(
      delay(defaultSearchDelay),
      finalize(() => this.spinnerService.stopSpinner()),
      catchError(this.handleErrors('getAllPaylocs', null))
    ).subscribe((data) => {
        let paylocs = data['output']['content'];
        paylocs.forEach( payloc => {
          this.dropdownService.getCountry(payloc.country).subscribe((code) => {
            payloc.countryName = code.longDescription;
          });
        });
      const totalPages: number = data['output']['totalPages'];
      const totalElements: number = data['output']['totalElements'];
      const currentPage: number = page;
      this.updateDataStore(paylocs, currentPage, totalPages, totalElements);
    },
    error => {
      this.handleError('getAllPaylocs', error);
   });
  }


  searchPaylocs(page) {
    this.spinnerService.startSpinner();
    this.search(this.paylocSearch, page).pipe(
      delay(defaultSearchDelay),
      finalize(() => this.spinnerService.stopSpinner()),
      catchError(this.handleErrors('getAllPaylocs', null))
    ).subscribe((data) => {
        let paylocs = data['output']['content'];
        paylocs.forEach( payloc => {
          this.dropdownService.getCountry(payloc.country).subscribe((code) => {
            payloc.countryName = code.longDescription;
          });
        });
      const totalPages: number = data['output']['totalPages'];
      const totalElements: number = data['output']['totalElements'];
      const currentPage: number = page;
      this.updateDataStore(paylocs, currentPage, totalPages, totalElements);

    },
     error => {
       this.handleError('searchPaylocs', error);
    });
  }

  getSinglePayloc(payNum){
    this.spinnerService.startSpinner();
    this.getSingle(payNum).pipe(
      delay(defaultSearchDelay),
      finalize(() => this.spinnerService.stopSpinner()),
      catchError(this.handleErrors('getAllPaylocs', null))
    ).subscribe((data) => {
      //this._paylocDetail.next(data['output']);
      this.payloc = data['output'];
    },
    error => {
      this.handleError('getSinglePayloc', error);
   });
  }

  private updateDataStore(paylocs, currentPage , totalPages, totalElements) {
    this.dataStore.next(paylocs);
    this.currentPage = currentPage;
    this.totalPages = totalPages;
    this.totalElements = totalElements;
    this.hasSearchResults = paylocs.length !== 0;
    this.hasSearched = true;
  }

}
